import { Injectable } from '@angular/core';
import { AppConfigService } from './services/app-config.service';
import { AuthService } from './auth.service';
import { ConfigService } from './config.service';
import { TelemetryService } from '@infosys-it/angular-telemetry-sdk';

@Injectable({
  providedIn: 'root'
})
export class TelemetryStartService {


  //telemetry service created to handle only telemetry events. Start event is configured now.


  constructor(private config:ConfigService,private authUtil: AuthService,
    private telemetryService: TelemetryService
  ) { }
  BATCH_SIZE = 1;
  TELEMETRY_SERVICE_HOST = this.config.getSettings().Telemetry;
  TELEMETRY_SERVICE_ENDPOINT = '/v1/telemetry';

  telemetryStartWithConfig(){
    let telemetryConfig = {
      'pdata': {
          'id': this.config.getSettings().TYPE+'.angular-AAPRiseEmployeeUITelemetry.UI',
          'ver': '1.0.0',
          'pid': 'AAPRiseEmployeeUITelemetry-UI'
      },
      'uid': localStorage.getItem("upn"),
      'authtoken': this.authUtil.getAccessToken(),
      'env':  this.config.getSettings().TYPE,
      'channel': "AAPRiseEmployeeUITelemetry",
      'batchsize': this.BATCH_SIZE,
      'host': this.TELEMETRY_SERVICE_HOST,
      'endpoint': this.TELEMETRY_SERVICE_ENDPOINT,
      // 'host':"https://isgatewaytst.ad.infosys.com/telemetry",
      // 'endpoint': "/v1/telemetry",
      'apislug': ''
    };
    let options = {
      actor: {
        "id": "Yogesh_R01",
        "type": "user"
      },
      context: {
        "channel": "AAPRiseEmployeeUITelemetry",
      },
      pdata: {
         "id":this.config.getSettings().TYPE+'.angular-AAPRiseEmployeeUITelemetry.UI',
         "ver": 1,
         "pid": null
      },
    };
    this.telemetryService.provider = 'SUNBIRD';
    this.telemetryService.setProviderImplementation('SUNBIRD',{});
   this.telemetryService.start(telemetryConfig, 'contentId1', 1, telemetryConfig,options);
  }


}